import { Alert } from '@chakra-ui/react';
import { PropsWithChildren } from 'react';
import { FormProvider, useForm, useFormContext } from 'react-hook-form';

export const Form = ({
    onSubmit,
    defaultValues = {},
    children,
    id,
    debug,
}: PropsWithChildren<{ onSubmit: (data: any) => void; defaultValues?: any; id?: string; debug?: boolean }>) => {
    const methods = useForm({ defaultValues });

    return (
        <FormProvider {...methods}>
            <form
                id={id}
                onSubmit={(ev) => {
                    ev.preventDefault();
                    methods.handleSubmit(onSubmit)(ev);
                }}
            >
                {debug && <FormState />}
                {children}
            </form>
        </FormProvider>
    );
};

const FormState = () => {
    const { formState, watch } = useFormContext();
    const values = watch();

    return (
        <Alert status="warning" variant="subtle" p={4} my={2}>
            <pre style={{ overflow: 'scroll', maxHeight: '400px', fontSize: '12px', fontFamily: 'inherit' }}>
                {JSON.stringify(
                    {
                        values,
                        formState,
                    },
                    undefined,
                    8,
                )}
            </pre>
        </Alert>
    );
};
